import { FC, ReactElement } from 'react';

import classNames from 'classnames';

import { Button, Icon } from '../../components';
import { capitalizeFirstCharacter } from '../../helpers/string';
import { SkillBase } from '../../models/@competentNL/Skills/Skills';

import './SkillOption.scss';

interface SkillOptionProps {
    option: SkillBase;
    selectedOptions: SkillBase[];
    onSelectOption: (selectedOption: SkillBase) => void;
    className?: string;
}

const SkillOption: FC<SkillOptionProps> = ({
    option,
    selectedOptions,
    onSelectOption,
    className = '',
}): ReactElement => {
    const skillIsSelected = selectedOptions.find(existingOption => existingOption.id === option.id);

    const handleClick = (): void => onSelectOption(option);

    const buttonClassNames = classNames('skill-option__button', {
        'skill-option__button--is-selected': skillIsSelected,
    });

    return (
        <li className={`skill-option ${className}`}>
            <Button
                text={option.label}
                onClick={handleClick}
                className={buttonClassNames}
            >
                <span className="skill-option__label">
                    {capitalizeFirstCharacter(option.label)}
                </span>

                <div className="skill-option__icon-wrapper">
                    <Icon
                        name={skillIsSelected ? 'cross' : 'plus'}
                        className="skill-option__icon"
                    />
                </div>
            </Button>
        </li>
    );
};

export default SkillOption;
